import { motion } from "framer-motion";
import { IMG } from "../data/content";

export const PageHero = ({ eyebrow, title, description, image = IMG.stagePurple }) => (
  <section className="relative pt-36 pb-20 sm:pt-44 sm:pb-28 overflow-hidden grain" data-testid="page-hero">
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#070708]/80 via-[#070708]/70 to-[#070708]" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="text-xs uppercase tracking-[0.35em] text-[#C9A55C] mb-5"
      >
        {eyebrow}
      </motion.p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] text-[#F3EEE5] max-w-3xl">
        <span className="mask-line">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.span>
        </span>
      </h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-6 max-w-2xl text-[#A9ABB2] leading-relaxed text-sm sm:text-base"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
